import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { PhotoPlaceholder } from './PhotoPlaceholder';
import { whyPoints } from '../data/homepage';
export function WhyUs() {
  return <section id="why-us" aria-labelledby="why-heading" className="on-light bg-paper py-24 md:py-32" data-id="element-175" data-mp="17kre72p7p5rr">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 md:grid-cols-2 md:gap-16 md:px-10 lg:gap-24" data-id="element-176" data-mp="12ry92dptzvf5">
        <Reveal className="aspect-[4/5] w-full overflow-hidden rounded-sm" data-id="element-177" data-mp="1git9d1m9l474">
          <PhotoPlaceholder description="Documentary portrait of the Veterans For Life team together, in plain clothes, in their working space. Honest, unposed." alt="The Veterans For Life team, former military medical personnel, standing together in their office." supplySize="1200 × 1500 px or larger" data-id="element-178" data-mp="1chr9cikiwo43" />
        </Reveal>

        <Reveal delay={0.05} data-id="element-179" data-mp="3nb3u3wlrru1i">
          <h2 id="why-heading" className="font-serif text-4xl font-semibold leading-tight text-navy md:text-5xl" data-id="element-180" data-mp="3nbvsff6r45vh">
            We've worn the same boots.
          </h2>
          <div aria-hidden="true" className="mt-8 h-px w-16 bg-gold" data-id="element-181" data-mp="3j9msidu3hhys" />
          <p className="mt-8 text-lg leading-relaxed text-charcoal md:text-xl" data-id="element-182" data-mp="3j7s8d1qndtvr">
            We are not a faceless corporation and we are not a chatbot. We are a small team who served, most of
            us in military medicine, and we treat your claim like it belongs to one of our own.
          </p>
          <ul className="mt-10 space-y-5" data-id="element-183" data-mp="xzqhq42h2nt">
            {whyPoints.map(point => <li key={point} className="flex items-start gap-4" data-id="element-184" data-mp="5t5ceoxgyhbw">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-navy" data-id="element-185" data-mp="av4ezwldxa7s">
                  <CheckIcon aria-hidden="true" className="h-4 w-4 text-gold" strokeWidth={3} data-id="element-186" data-mp="eudbh97t7m71" />
                </span>
                <span className="text-lg leading-relaxed text-charcoal" data-id="element-187" data-mp="2cn92mvvuplcp">{point}</span>
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}